// Leitura dos cookies de origem gravados por public/medicao/atribuicao.js.
//
// O problema que isto resolve: quem clica no anúncio do infoprodutor faz o
// Raio-X lá e só então vem para cá preencher o formulário. Trocou de site no
// meio do caminho. Os parâmetros da campanha ficaram na URL da outra página, e
// sem ler o cookie de domínio este formulário registraria o lead como se
// tivesse vindo do nada, deixando sem crédito a campanha que pagou pela pessoa.
//
// Quem escreve é o atribuicao.js, em `.biancode.com.br`, e por isso os três
// sites enxergam o mesmo valor. Aqui só se lê.

const PRIMEIRO = 'bc_attr_first';
const ULTIMO = 'bc_attr_last';

const lerCookie = (nome) => {
  if (typeof document === 'undefined') return null;
  const achado = document.cookie.split('; ').find((c) => c.startsWith(nome + '='));
  if (!achado) return null;
  try {
    const valor = JSON.parse(decodeURIComponent(achado.slice(nome.length + 1)));
    return valor && typeof valor === 'object' ? valor : null;
  } catch {
    return null;
  }
};

/**
 * Primeira visita e último clique, já no formato que o ERP guarda.
 * Prefere o que o atribuicao.js tem em memória: quem acabou de aceitar os
 * cookies ainda não tem o valor gravado, mas a visita atual já é conhecida.
 */
export const lerAtribuicao = () => {
  const emMemoria = typeof window !== 'undefined' ? window.bcAtribuicao : null;
  const primeiro = emMemoria?.primeiro ? emMemoria.primeiro() : lerCookie(PRIMEIRO);
  const ultimo = emMemoria?.ultimo ? emMemoria.ultimo() : lerCookie(ULTIMO);
  return { primeiro: primeiro || null, ultimo: ultimo || null };
};

const CAMPOS_UTM = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

/**
 * UTMs para mandar ao ERP, combinando o que esta página viu com o que o
 * cookie guardou.
 *
 * A URL desta visita manda quando existe: é o clique mais recente. O cookie
 * entra onde ela está calada, que é o caso de quem veio do Raio-X sem
 * parâmetro nenhum na URL do formulário.
 */
export const utmsParaOErp = (daPagina) => {
  const { ultimo } = lerAtribuicao();
  const out = { ...(daPagina || {}) };
  for (const campo of CAMPOS_UTM) {
    if (!out[campo] && ultimo?.[campo]) out[campo] = ultimo[campo];
  }
  return out;
};

/** O consentimento declarado nesta visita, para o servidor saber se pode avisar as plataformas. */
export const consentimentoAtual = () =>
  (typeof window !== 'undefined' && window.bcConsentimento) || { medicao: false, publicidade: false };

const CONHECIDAS = [
  [/facebook|instagram|meta|^fb$|^ig$/, 'meta'],
  [/google|adwords|gads|youtube/, 'google'],
  [/chatgpt|openai/, 'chatgpt'],
];

/**
 * De qual plataforma de anúncio veio o último clique.
 *
 * Mesma regra da landing de fábrica de software, e de propósito: é por este
 * campo que o painel agrupa, e duas páginas classificando diferente dariam dois
 * números para a mesma pergunta.
 *
 * "outro" e "organico" não são a mesma coisa. Quem veio por uma campanha que
 * não está na lista pagou pelo clique; chamar isso de orgânico esconde o custo.
 */
export const plataformaDoUltimoClique = (utms) => {
  const { ultimo } = lerAtribuicao();
  const fonte = String(utms?.utm_source || ultimo?.utm_source || '').toLowerCase();
  if (fonte) {
    const achada = CONHECIDAS.find(([re]) => re.test(fonte));
    return achada ? achada[1] : 'outro';
  }
  // Autotagging do Google Ads não põe utm nenhuma: sem esta linha o lead mais
  // caro seria contado como orgânico.
  if (ultimo?.gclid || ultimo?.gbraid || ultimo?.wbraid) return 'google';
  if (ultimo?.fbclid) return 'meta';
  return 'organico';
};
